import type { PropsWithChildren } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import SplashScreen from '../../../components/global/SplashScreen'
import useAuth from '../useAuth'

interface RedirectLocationState {
  from?: {
    pathname?: string
  }
  loggedOut?: boolean
}

export default function GuestGuard({ children }: PropsWithChildren) {
  const location = useLocation()
  const { isInitializing, userId } = useAuth()

  if (isInitializing) return <SplashScreen>Authenticating...</SplashScreen>
  if (userId) {
    const state = location.state as RedirectLocationState | undefined
    const redirectPath = state?.loggedOut ? '/' : state?.from?.pathname || '/'
    return <Navigate to={redirectPath} replace />
  }
  return <>{children}</>
}
